import styled from "@emotion/styled";
import colors from "/styles/colors";
import { DARK_WORK_OS_IRIS_COLOR_NAME } from "styles/color-consts";
export const StyledFooterCategoryComponent = styled.div`
  .footer-category-image-and-title-warpper {
    .monday-logo-wrapper {
      margin-bottom: 14px;

      .footer-monday-logo-image {
        height: 32px;
      }
    }

    .title {
      margin-top: 10px;
      margin-bottom: 24px;
      font-size: 0.875rem;
      font-weight: 500;
    }
  }

  .link {
    line-height: 22px;

    &:not(:last-child) {
      margin-bottom: 16px;
    }

    &:hover {
      color: ${colors[DARK_WORK_OS_IRIS_COLOR_NAME]};
    }

    a {
      text-decoration: none;
      color: inherit;
      display: flex;
      column-gap: 8px;
      align-items: center;

      .footer-link-icon {
        display: flex;
        align-items: center;
        flex-shrink: 0;

        svg {
          width: 18px;
          height: 18px;
        }
      }

      .picture-component {
        display: flex;

        img {
          height: 18px;
        }
      }
    }

    .link-tag {
      font-size: 0.5rem;
      font-weight: 400;
      color: ${colors.asphalt};
      background-color: #f0f0f0;
      padding: 3px 6px;
      border-radius: 4px;
      line-height: normal;
      white-space: nowrap;
    }
  }
`;
